import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=502b1a8d&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=502b1a8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b1a8d",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BTab, BTabs, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BTab, BTabs, BContainer})
    

export default component.exports